export default __webpack_public_path__ + "static/media/tilføj.819d1115.png";